import { RouteConfig } from 'vue-router';

// Component
import SystemsStep from './Systems.vue';

// Step types
import { Step } from './../types';

// Actual steps to get the meta
import Steps from './../steps';

/**
 *  Routes for the systems step.
 */
const routes: RouteConfig[] = [
    {
        name: Step.Systems,
        path: process.env.NODE_ENV === 'development' ? '/systems' : '/tool/systems',
        component: SystemsStep,
        meta: Steps[Step.Systems],
    },
];

export default routes;
